import angular from 'angular';
import { includes } from 'lodash';

module.exports = angular.module('common.filters.contains', [])
.filter('contains', () => includes)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/contains.js
 **/